import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(
	theme => ({
		gridTitleContainer: {
			[theme.breakpoints.up('lg')]: {
				justifyContent: ({ metaData }) => metaData.titleAlign?.contentAlignment(),
			},

			[theme.breakpoints.down('md')]: {
				justifyContent: ({ metaData }) => metaData.mobileAlignment?.contentAlignment(),
			},
		},
		gridContainer: {
			width: `calc(100% + ${theme.spacing(3)})`,
			marginLeft: theme.spacing(-1.5),
			marginRight: theme.spacing(-1.5),
			marginTop: theme.spacing(2),
			marginBottom: theme.spacing(3),
		},
		item: {
			marginBottom: 2,
			[theme.breakpoints.up('sm')]: {
				maxWidth: theme.spacing(38.6),
			},
			[theme.breakpoints.down('sm')]: {
				padding: theme.spacing(1.5),
			},
		},
		titleWrap: {
			marginBottom: theme.spacing(5.6),
		},
		container: {
			overflow: 'hidden',
		},

		text: {
			[theme.breakpoints.down('md')]: {
				'& *': {
					textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
				},
			},
		},
	}),
	{ name: 'Category-Category6' },
)

export default useStyles
